// «Что нового» в кабинете ClipCut (V2T-42 · M2).
// Записи — src/data/whatsNew.json (едут со сборкой фронта). Просмотр помним в localStorage:
// id самой свежей записи, которую юзер уже видел. Бейдж = записи свежее этой метки.
// Состояние общее для бокового меню и мобильной шапки — один reactive на модуль.
import { reactive } from 'vue';
import data from '@/data/whatsNew.json';

const SEEN_KEY = 'whatsnew_seen_clipcut';
const PREVIEW_KEY = 'whatsnew_preview';

function readStorage(key) {
  try {
    return localStorage.getItem(key) || '';
  } catch (e) {
    return '';
  }
}

export const whatsNewState = reactive({
  seenId: readStorage(SEEN_KEY),
  open: false
});

// id вида YYYY-MM-DD-N; сравниваем по дате, затем по номеру
function compareIds(a, b) {
  const pa = String(a).split('-').map(Number);
  const pb = String(b).split('-').map(Number);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d) return d;
  }
  return 0;
}

// Блок есть только у ClipCut — остальные боты собираются тем же фронтом
const CLIPCUT_FAMILY = ['clipcut', 'clipcutglobal', 'clipcutbr', 'narezkavideo'];

// Бот из configData: у анонимного посетителя app.clipcut.ru chatbot_name пустой,
// заполнен только service_name (так же решает isClipCut в SideMenuComponent)
function botOf(configData) {
  return (configData && (configData.chatbot_name || configData.service_name)) || '';
}

export function whatsNewEntries(configData, locale) {
  const chatbotName = botOf(configData);
  if (!CLIPCUT_FAMILY.includes(chatbotName)) return [];
  const preview = readStorage(PREVIEW_KEY) === '1';
  const lang = (locale || 'ru').slice(0, 2);
  return (data.entries || [])
    .filter(e => preview || !e.draft)
    .filter(e => !e.products || e.products.includes(chatbotName))
    .filter(e => e.title && (e.title[lang] || e.title.ru))
    .sort((a, b) => compareIds(b.id, a.id))
    .map(e => ({
      id: e.id,
      date: e.date,
      draft: !!e.draft,
      title: e.title[lang] || e.title.ru,
      text: (e.text && (e.text[lang] || e.text.ru)) || ''
    }));
}

// Черновики в бейдж не попадают даже в режиме превью — бейдж мерит то, что видят юзеры
export function whatsNewUnseenCount(configData, locale) {
  return whatsNewEntries(configData, locale)
    .filter(e => !e.draft && (!whatsNewState.seenId || compareIds(e.id, whatsNewState.seenId) > 0))
    .length;
}

export function openWhatsNew(configData, locale) {
  whatsNewState.open = true;
  const published = whatsNewEntries(configData, locale).filter(e => !e.draft);
  if (!published.length) return;
  const newest = published[0].id;
  if (!whatsNewState.seenId || compareIds(newest, whatsNewState.seenId) > 0) {
    whatsNewState.seenId = newest;
    try {
      localStorage.setItem(SEEN_KEY, newest);
    } catch (e) {
      // приватный режим — бейдж просто погаснет до перезагрузки
    }
  }
}
